import marketColors from '@/creditflowresearch/ui/common/styles/marketColors';
import EmergingMarket from '@/creditflowresearch/domain/Market/entities/EmergingMarket';

export const MARKET_COLORS = {
  [EmergingMarket.ABBREVIATION]: marketColors.colorMarketEm,
} as const;

export const MARKET_GRADIENTS = {
  [EmergingMarket.ABBREVIATION]: marketColors.gradientMarketEm,
} as const;

export const getMarketColor = (abbreviation: string): string => {
  return MARKET_COLORS[abbreviation] || '';
};

export const getMarketGradient = (abbreviation: string): string => {
  return MARKET_GRADIENTS[abbreviation] || '';
};
